import { locationChangePersist, ListStoreDefault, ListRequestHandler, ListFilterHandler, ListSuccessHandler } from 'js/helpers/reducers.js';

import {
  FETCH_SEARCH_FEED,
  FETCHED_SEARCH_FEED,
  SET_SEARCH_FEED_FILTER,
 } from 'components/Pages/SearchFeed/actions.js';

export const initialFilters = {
  pageSize: 40,
  pageNum: 1,
  startDate: '',
  endDate: '',
  content_type: '',
  content_format: '',
  length: '',
  brand_ids: [],
  publisher_ids: [],
  keyword_tags: [],
  titles: [],
  phrases: [],
  searchQuery: '',
  searchBy: '',
  sortBy: 'publish_date',
  sortOrder: 'desc',
};

const defaultState = {
  contentList: ListStoreDefault(initialFilters),
};

const SearchFeedReducer = (state = defaultState, action) => {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
      return locationChangePersist(state, action, defaultState, {
        sections: ['contentList'],
        pathToMatch: `/blueprint/search`,
      });
    case FETCH_SEARCH_FEED:
      return ListRequestHandler(state, action, 'contentList');
    case FETCHED_SEARCH_FEED:
      return ListSuccessHandler(state, action, 'contentList');
    case SET_SEARCH_FEED_FILTER:
      return ListFilterHandler(state, action, 'contentList');
    default:
      return Object.assign({}, state);
  }
};

export default SearchFeedReducer;
